import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Loader from 'src/components/Loader';
import TabsContainer from 'src/containers/TabsContainer';
import AdvicesContainer from 'src/containers/AdvicesContainer';
import 'src/containers/LayoutContainer.scss';


const LayoutContainer = ({ processing }) => {
  const headline = 'Porady dla Ciebie';

  return (
    <div data-test="section-advices" styleName="layout">
      <div styleName="layout__categories">
        <h2 styleName="layout__headline">{ headline }</h2>
        <TabsContainer />
      </div>
      <div styleName="layout__advices">
        { processing ? <Loader /> : <AdvicesContainer /> }
      </div>
    </div>
  );
};

LayoutContainer.propTypes = {
  processing: PropTypes.bool.isRequired
};


const mapStateToProperties = state => ({
  processing: state.tabsReducer.processing
});

export { LayoutContainer };

export default connect(mapStateToProperties)(LayoutContainer);
